import { emptyApi } from "./emptyApi";

export type TagChoice =
  | "VC_TAG"
  | "COMPANY_GROUP_TAG"
  | "TASK_TAG"
  | "PROFILE_TAG"
  | "CRM_TAG"
  | "INDIA_LAW_FIRM_TAG"
  | "US_LAW_FIRM_TAG"
  | "CURRENT_CPA"
  | "COMPANY_GROUP_USER_MAP_TAG"
  | "PERK_TAG"
  | "DOCUMENT_TAG"
  | "ENTITY_TRANSACTION_TAG"
  | "AUTOFILL_ADDRESS_TYPE_TAG"
  | "AUTOFILL_PERSON_TYPE_TAG"
  | "TICKETS_TAG"
  | "SERVICE_TEAM_TAG";

const extendedApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    getAllTagChoices: build.query<TagChoice[], void>({
      query: () => ({
        url: `/api/inkle/tags/choices/`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAllTagChoicesQuery } = extendedApi;
